import LoLWelcome from './LoLWelcome';

export default LoLWelcome;
